define([
    "../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    hereMapsModule.service("hereMapsRoutesFactory", [
        "hereMapsService",
        function (hereMapsService) {
            var Here = null;
            return {
                createRoute: createRoute,
                createPolyline: createPolyline
            };

            function createRoute(route, data, style) {
                Here = hereMapsService.getHere();
                var routePolyline = null;
                route.results.forEach(function (resultRoute) {
                    resultRoute.routes.forEach(function (routeResult) {
                        var routePath = createPathFromRoute(routeResult);
                        if (routePath && routePath.length >= 2) {
                            routePolyline = createPolyline(routePath, route.color, data, style);
                        }
                    });
                });
                return routePolyline;
            }

            function createPathFromRoute(routeResult) {
                return (routeResult.legs || []).map(function (leg) {
                    if (!leg.steps.length) {
                        return [leg.start, leg.end];
                    }
                    return leg.steps.map(function convertStep(step) {
                        var detailedPoints = step.points;

                        // temporário, quando só tem um ponto na rota
                        if (detailedPoints.length === 1) {
                            detailedPoints.push(detailedPoints[0]);
                        }
                        if (step.steps) {
                            detailedPoints = step.steps.map(convertStep);
                        }
                        // return [step.start].concat(detailedPoints).concat(step.end);
                        return detailedPoints;
                    }).reduce(flatten, []);
                }).reduce(flatten, [])
                    .filter(function (pos) {
                        return pos !== null;
                    })
                    .map(function (pos) {
                        return {lat: pos.latitude, lng: pos.longitude};
                    });

                function flatten(a, b) {
                    return a.concat(b);
                }
            }

            function createPolyline(routesPath, color, data, style) {
                if (!routesPath || routesPath.length === 1) {
                    return null;
                }
                var lineString = new Here.geo.LineString();
                routesPath.forEach(function (routePath) {
                    lineString.pushPoint(routePath);
                });

                return new Here.map.Polyline(lineString, {
                    style: getStyle(color, style),
                    data: data
                });
            }

            function getStyle(color, style) {
                if (style) {
                    return style;
                }
                return {
                    strokeColor: color,
                    lineWidth: 3
                };
            }
        }
    ]);
});